<template>
<div>
  <Header/>
  <Navigationzj/>
  <div class="hxq_subpage">
    <div class="zmpp_con w1200">
      <div class="hxq_yzjk_mbx" style="padding-left: 0px">
        <a href="/" class="allResult">首页<span class="newspan">></span></a>帮助中心
      </div>
      <div class="demo-image__preview" style="width:100%;display: inline-block;">
        <!--左侧导航开始-->
        <div>
          <LeftNavs :leftNavis='12'/>
        </div>
        <!--左侧导航结束-->
        <div class="cght_htmainrights">
          <div class="loading-wrap">
            <div class="content-title-wrap">
              <div class="content-title">发货交期说明</div>
            </div>
            <div class="loading-box">
              <div class="n_right_line">
                <div class="n_title_line">
                  <div class="icon-background">
                    <div class="icon-content"><i class="el-icon-date"></i></div>
                  </div>
                  <div class="n_right_head">
                    <p>发货交期说明</p>
                  </div>
                </div>
                <div class="n-content">
                  <ul class="n_content_list no_indent">
                    <li>
                      <h3>发货时效说明：</h3>
                      <div class="clearfix send-date-list">
                        <div class="send-date-item">
                          <div class="pdt-status-tag type1">现货</div>
                          <div class="send-date-des">工作日12:00之前提交的订单，志鹏供应链<i class="send-date-tag day1">当日发货</i></div>
                          <div class="send-date-des">工作日12:00之后提交的订单，志鹏供应链<i class="send-date-tag day2">次日发货</i></div>
                        </div>
                        <div class="send-date-item">
                          <div class="pdt-status-tag type2">订货</div>
                          <div class="send-date-des">库存均不满足用户需求时，按照需订货的参考发货日出货。</div>
                        </div>
                        <div class="send-date-item">
                          <div class="pdt-status-tag type3">无货</div>
                          <div class="send-date-des">特殊情况下，如商品售罄或无库存导致无法供应，如有需求可咨询志鹏供应链客服。</div>
                        </div>
                        <div class="send-date-item">
                          <div class="send-date-tip last">温馨提醒：特殊产品的具体发货日信息请咨询在线客服<br>&nbsp;&nbsp;&nbsp;或拨打客服热线<span class="textRed">400-040-7890</span>。</div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <h3>发货方式说明：</h3>
                      <p>志鹏供应链将对订单确定的地址提供送货上门配送服务。同一订单中各项产品若交期不同，您可以选择在最长发货日期统一发货，或 按各项产品实际交期分别发货。具体请咨询在线客服或拨打客服热线<i class="textRed">400-040-7890</i>。</p>
                    </li>
                    <li class="shipping-efficiency">
                      <h3>配送时效说明：</h3>
                      <p>原则上，志鹏供应链发出的商品会按照客户的收货地区对应的就近仓库发货，危险品除外。<br>志鹏供应链会根据客户收货地、商品体积的大小来安排配送方式（自营/快递/物流），不同地区对应配送方式的时效不同。<br></p>
                    </li>
                  </ul>
                  <div v-show="false" class="n_content_line">
                    <div class="thead">
                      <span class="table-cell">收货区域</span>
                      <span class="table-cell">普通件配送时效</span>
                      <span class="table-cell">危险品配送时效</span>
                    </div>
                    <ul class="delivery-time-wrap">
                      <li>
                        <h3>上海市</h3>
                        <p>1天</p>
                        <span>1-2天</span>
                      </li>
                      <li>
                        <h3>浙江省</h3>
                        <p>1-2天</p>
                        <span>1-3天</span>
                      </li>
                      <li>
                        <h3>江苏省</h3>
                        <p>1-2天</p>
                        <span>1-2天</span>
                      </li>
                      <li>
                        <h3>安徽省</h3>
                        <p>1-3天</p>
                        <span>2-3天</span>
                      </li>
                      <li>
                        <h3>四川省</h3>
                        <p>1-4天</p>
                        <span>6-10天</span>
                      </li>
                      <li>
                        <h3>重庆市</h3>
                        <p>2-3天</p>
                        <span>6天</span>
                      </li>
                      <li>
                        <h3>云南省</h3>
                        <p>3-5天</p>
                        <span>6-10天</span>
                      </li>
                      <li>
                        <h3>贵州省</h3>
                        <p>3-4天</p>
                        <span>6-7天</span>
                      </li>
                      <li>
                        <h3>西藏自治区</h3>
                        <p>7天</p>
                        <span>12-14天</span>
                      </li>
                      <li>
                        <h3>甘肃省</h3>
                        <p>3-6天</p>
                        <span>7-9天</span>
                      </li>
                      <li>
                        <h3>青海省</h3>
                        <p>3-6天</p>
                        <span>7-10天</span>
                      </li>
                      <li>
                        <h3>宁夏回族自治区</h3>
                        <p>3-5天</p>
                        <span>7-8天</span>
                      </li>
                      <li>
                        <h3>北京市</h3>
                        <p>1天</p>
                        <span>4天</span>
                      </li>
                      <li>
                        <h3>天津市</h3>
                        <p>1天</p>
                        <span>3天</span>
                      </li>
                      <li>
                        <h3>河北省</h3>
                        <p>1-3天</p>
                        <span>3-4天</span>
                      </li>
                      <li>
                        <h3>内蒙古自治区</h3>
                        <p>3-6天</p>
                        <span>7-8天</span>
                      </li>
                      <li>
                        <h3>山西省</h3>
                        <p>2-3天</p>
                        <span>4-5天</span>
                      </li>
                      <li>
                        <h3>辽宁省</h3>
                        <p>1-3天</p>
                        <span>6天</span>
                      </li>
                      <li>
                        <h3>吉林省</h3>
                        <p>3-5天</p>
                        <span>6-8天</span>
                      </li>
                      <li>
                        <h3>黑龙江省</h3>
                        <p>3-7天</p>
                        <span>6-9天</span>
                      </li>
                      <li>
                        <h3>湖北省</h3>
                        <p>1-4天</p>
                        <span>3-7天</span>
                      </li>
                      <li>
                        <h3>湖南省</h3>
                        <p>2-4天</p>
                        <span>3-5天</span>
                      </li>
                      <li>
                        <h3>江西省</h3>
                        <p>4天</p>
                        <span>3-4天</span>
                      </li>
                      <li>
                        <h3>河南省</h3>
                        <p>3天</p>
                        <span>3-4天</span>
                      </li>
                      <li>
                        <h3>山东省</h3>
                        <p>1-2天</p>
                        <span>3-4天</span>
                      </li>
                      <li>
                        <h3>广东省</h3>
                        <p>1-2天</p>
                        <span>4-5天</span>
                      </li>
                      <li>
                        <h3>广西壮族自治区</h3>
                        <p>3-4天</p>
                        <span>6-7天</span>
                      </li>
                      <li>
                        <h3>海南省</h3>
                        <p>3-4天</p>
                        <span>7-8天</span>
                      </li>
                      <li>
                        <h3>福建省</h3>
                        <p>4-5天</p>
                        <span>3-4天</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>
<script>
import Header from '@/components/Header'
import Navigationzj from '@/components/Navigationzj'
import Footer from '@/components/Footer'
import LeftNavs from '@/components/Help/Left_navs'

export default {
  name: 'Help',
  components: {
    Header,
    Navigationzj,
    Footer,
    LeftNavs
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.cght_htmainrights .loading-wrap {
  margin-left: 252px;
  top: 0;
  left: 0;
  right: 0;
}
.loading-wrap .content-title-wrap {
  height: 42px;
  background: #f7f7f7;
}
.loading-wrap .content-title-wrap .content-title {
  float: left;
  width: auto;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #666;
  line-height: 42px;
  margin-left: 16px;
}
.loading-wrap .loading-box {
  background-size: 74px auto;
  border-left: 1px dashed #e8e8e8;
  margin-left: 43px;
  margin-top: 25px;
  margin-bottom: 40px;
  height: auto;
}
.n_right_line {
  padding-bottom: 40px;
}
.n_right_line .n_title_line {
  text-align: left;
  margin-left: -30px;
}
.n_right_line .n_title_line .icon-background {
  float: left;
  margin-left: 10px;
  margin-right: 11px;
  width: 40px;
  height: 40px;
  background-color: #436aa6;
  border-radius: 50%;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n_title_line .icon-background .icon-content {
  text-align: center;
  line-height: 40px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}
.n_right_line .n_title_line .n_right_head {
  display: inline-block;
  margin-left: 21px;
  margin-top: 10px;
}
.n_right_line .n_title_line .n_right_head p {
  font-size: 18px;
  color: #333;
  line-height: 20px;
  margin-bottom: 6px;
}
.n_right_line .n_title_line .n_right_head span {
  display: inline;
  font-size: 14px;
  color: #666;
  line-height: 20px;
}
.n_right_line .n_content {
  margin-top: 20px;
  margin-left: 45px;
  text-align: left;
}
.n_right_line .n_content img {
  width: 855px;
}
.n_right_line .n-content {
  margin-top: 30px;
  margin-left: 45px;
  text-align: left;
  text-indent: 10px;
  font-size: 14px;
  text-indent: 2em;
  line-height: 30px;
  color: #000;
}
.n_right_line .n-content .n_content_list {
  width: 784px;
  margin-left: 10px;
}
.n_right_line .n-content .no_indent {
  text-indent: 0;
}
.n_right_line .n-content .n_content_list li {
  min-height: 90px;
  border-bottom: 1px solid #e5e5e5;
  padding-top: 20px;
  padding-bottom: 8px;
}
.n_right_line .n-content .n_content_list li h3 {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  display: inline-block;
  margin-bottom: 16px;
}
.loading-wrap .loading-box:last-child {
  padding-bottom: 0;
}
.n_right_line .n-content .n_content_list li .send-date-list {
  margin-left: -22px;
  height: 330px;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item {
  position: relative;
  float: left;
  width: 383px;
  height: 150px;
  font-size: 14px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgb(4 0 0 / 12%);
  border-radius: 3px;
  margin-left: 20px;
  margin-bottom: 20px;
  padding: 40px 30px 0 20px;
  box-sizing: border-box;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .pdt-status-tag.type1 {
  color: #3c89e1;
  border: 1px solid #3c89e1;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .pdt-status-tag {
  position: absolute;
  top: 15px;
  left: 19px;
  height: 18px;
  line-height: 18px;
  padding: 0 4px;
  border-radius: 3px;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .send-date-des {
  line-height: 30px;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .send-date-tag.day1 {
  background-color: #f74747;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .send-date-tag {
  border-radius: 3px;
  color: #fff;
  line-height: 22px;
  padding: 0 5px;
  margin-left: 5px;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .send-date-tag.day2 {
  background-color: #ed760c;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .pdt-status-tag.type2 {
  color: #f3942a;
  border: 1px solid #f3942a;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .pdt-status-tag.type3 {
  color: #fb4848;
  border: 1px solid #fb4848;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .send-date-tip.last {
  color: #666;
  text-align: center;
  line-height: 20px;
}
.n_right_line .n-content .n_content_list li .send-date-list .send-date-item .send-date-tip {
  font-size: 12px;
  color: #999;
  padding-top: 10px;
}
.textRed {
  color: #ed0d1f;
}
.loading-wrap .loading-box :last-child {
  padding-bottom: 0;
}
.n_right_line .n-content .n_content_line {
  width: 100%;
  margin-top: 34px;
  margin-bottom: 34px;
}
.n_right_line .n-content .n_content_line .thead {
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  font-weight: 700;
  color: #666;
  line-height: 20px;
  background: #f5f5f5;
  white-space: nowrap;
}
.n_right_line .n-content .n_content_line .thead .table-cell {
  display: inline-block;
  width: 32%;
  line-height: 34px;
  text-align: center;
}
.n_right_line .n-content .n_content_line ul {
  border: 1px solid #e2e2e2;
  border-top: none;
}
.n_right_line .n-content .n_content_line ul li {
  width: 100%;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  color: #999;
  border-bottom: 1px solid #e2e2e2;
}
.n_right_line .n-content .n_content_line ul li h3, .n_right_line .n-content .n_content_line ul li p, .n_right_line .n-content .n_content_line ul li span {
  display: inline-block;
  width: 31%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/help/shiptime.vue